import baseStyled, { css as baseCss, ThemedCssFunction, ThemedStyledInterface } from 'styled-components';

import { AllRfqTheme } from './themes/types';

const styled = baseStyled as ThemedStyledInterface<AllRfqTheme>;
const css = baseCss as ThemedCssFunction<AllRfqTheme>;

export const AllRfq = styled.div`
  width: 100%;
  height: 100%;
`;
